/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Backup_Snapshot_DescInputs */



/**
* | output |
* | --- |
* | "Snapshots create restore points that let you go back to previous versions of your project." |
*
* @param {Options_Backup_Snapshot_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_backup_snapshot_desc = /** @type {((inputs?: Options_Backup_Snapshot_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Backup_Snapshot_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les instantanés créent des points de restauration pour revenir à des versions antérieures du projet.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Snapshots erstellen Wiederherstellungspunkte, mit denen Sie zu früheren Versionen Ihres Projekts zurückkehren können.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gli snapshot creano punti di ripristino che consentono di tornare alle versioni precedenti del progetto.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Снимки создают точки восстановления, позволяющие вернуться к предыдущим версиям проекта.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Las instantáneas crean puntos de restauración que le permiten volver a versiones anteriores de su proyecto.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("快照功能可以创建还原点，让您可以恢复到项目的先前版本。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スナップショットは、プロジェクトの以前のバージョンに戻ることができる復元ポイントを作成します。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्नैपशॉट ऐसे पुनर्स्थापना बिंदु बनाते हैं जो आपको अपने प्रोजेक्ट के पिछले संस्करणों पर वापस जाने की अनुमति देते हैं।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Os snapshots criam pontos de restauração que permitem retornar a versões anteriores do seu projeto.")
	return /** @type {LocalizedString} */ ("Snapshots create restore points that let you go back to previous versions of your project.")
});